/* Bear Baby Boutique – GiftOption in de cart.
   - Twee opties (cadeauverpakking, kaartje): elke checkbox voegt het bijbehorende product toe
     of haalt het weg en rendert de cart opnieuw via de sections-API, net als Dawn.
   - Kaartje en ontvanger: cart attributes, live opgeslagen via /cart/update.js en ook
     meegestuurd met het cartformulier (form-attribuut), dus zonder JavaScript werkt het ook. */
(() => {
  if (customElements.get('bb-gift-option')) return;

  const fetchJson = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => response.json());

  class BBGiftOption extends HTMLElement {
    connectedCallback() {
      this.context = this.dataset.context;
      this.toggles = Array.from(this.querySelectorAll('[data-gift-toggle]'));
      this.wrapAttribute = this.querySelector('[data-gift-wrap-attribute]');
      this.cardFields = this.querySelector('[data-card-fields]');
      this.fields = Array.from(this.querySelectorAll('[data-attribute]'));
      this.status = this.querySelector('[data-status]');
      this.counter = this.querySelector('[data-counter]');
      this.textarea = this.querySelector('textarea[data-attribute]');

      this.toggles.forEach((input) => {
        input.addEventListener('change', (event) => {
          event.stopPropagation();
          this.toggle(input.dataset.giftToggle, input.checked, input);
        });
      });
      this.fields.forEach((field) => {
        field.addEventListener('change', (event) => {
          event.stopPropagation();
          this.updateCounter();
          this.saveAttributes();
        });
        field.addEventListener('input', () => {
          this.updateCounter();
          clearTimeout(this.saveTimer);
          this.saveTimer = setTimeout(() => this.saveAttributes(), 900);
        });
      });
      this.updateCounter();
    }

    updateCounter() {
      if (this.counter && this.textarea) {
        this.counter.textContent = `${this.textarea.value.length}/${this.textarea.maxLength}`;
      }
    }

    collectAttributes() {
      const attributes = {};
      this.fields.forEach((field) => {
        const match = field.name.match(/^attributes\[(.+)\]$/);
        if (match) attributes[match[1]] = field.value.trim();
      });
      if (this.wrapAttribute) attributes.Cadeauverpakking = this.wrapAttribute.value;
      return attributes;
    }

    async saveAttributes() {
      try {
        await fetchJson(`${window.routes.cart_update_url}`, { attributes: this.collectAttributes() });
        this.setStatus(this.dataset.savedLabel);
      } catch (error) {
        this.setStatus(this.dataset.errorLabel, true);
      }
    }

    setStatus(text, isError = false) {
      if (!this.status) return;
      this.status.textContent = text || '';
      this.status.classList.toggle('is-error', isError);
      clearTimeout(this.statusTimer);
      if (text && !isError) this.statusTimer = setTimeout(() => (this.status.textContent = ''), 2500);
    }

    sectionsToRender() {
      if (this.context === 'drawer') {
        return [
          { id: 'cart-drawer', selector: '#CartDrawer' },
          { id: 'cart-icon-bubble', selector: '.shopify-section' },
        ];
      }
      const items = document.getElementById('main-cart-items');
      const footer = document.getElementById('main-cart-footer');
      const list = [{ id: 'cart-icon-bubble', selector: '.shopify-section' }];
      if (items) list.push({ id: items.dataset.id, target: items, selector: '.js-contents' });
      if (footer) list.push({ id: footer.dataset.id, target: footer, selector: '.js-contents' });
      return list;
    }

    async toggle(kind, checked, input) {
      if (kind === 'wrap' && this.wrapAttribute) this.wrapAttribute.value = checked ? 'ja' : 'nee';
      if (kind === 'card' && this.cardFields) {
        this.cardFields.hidden = !checked;
        if (checked && this.textarea) this.textarea.focus();
        if (!checked) {
          this.fields.forEach((field) => (field.value = ''));
          this.updateCounter();
        }
      }
      const variantId = kind === 'wrap' ? this.dataset.wrapVariantId : this.dataset.cardVariantId;
      const lineKey = kind === 'wrap' ? this.dataset.wrapLineKey : this.dataset.cardLineKey;
      // Geen product ingesteld: de optie is gratis, alleen de keuze en tekst opslaan.
      if (!variantId) {
        await this.saveAttributes();
        return;
      }
      input.disabled = true;
      const sections = this.sectionsToRender();
      const sectionIds = sections.map((section) => section.id);
      try {
        await fetchJson(`${window.routes.cart_update_url}`, { attributes: this.collectAttributes() });
        let state;
        if (checked) {
          state = await fetchJson(`${window.routes.cart_add_url}`, {
            items: [{ id: Number(variantId), quantity: 1, properties: { _bb_cadeau: kind } }],
            sections: sectionIds,
            sections_url: window.location.pathname,
          });
        } else if (lineKey) {
          state = await fetchJson(`${window.routes.cart_change_url}`, {
            id: lineKey,
            quantity: 0,
            sections: sectionIds,
            sections_url: window.location.pathname,
          });
        } else {
          input.disabled = false;
          return;
        }
        if (state.status) throw new Error(state.description || state.message);
        this.render(sections, state.sections || {});
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bb-gift-option', cartData: state });
        }
      } catch (error) {
        input.checked = !checked;
        input.disabled = false;
        if (kind === 'card' && this.cardFields) this.cardFields.hidden = checked;
        this.setStatus(this.dataset.errorLabel, true);
      }
    }

    render(sections, html) {
      sections.forEach((section) => {
        const markup = html[section.id];
        if (!markup) return;
        const doc = new DOMParser().parseFromString(markup, 'text/html');
        const source = doc.querySelector(section.selector);
        if (!source) return;
        if (section.id === 'cart-drawer') {
          const drawer = document.querySelector('#CartDrawer');
          if (drawer) drawer.innerHTML = source.innerHTML;
          return;
        }
        if (section.id === 'cart-icon-bubble') {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = source.innerHTML;
          return;
        }
        const target = section.target && section.target.querySelector(section.selector);
        if (target) target.innerHTML = source.innerHTML;
      });
    }
  }

  customElements.define('bb-gift-option', BBGiftOption);
})();
